<template>
  <div>
    <b-card title="Görsel">
      <b-img
        v-if="dataItem.cta_image"
        :src="imageUrl + '/media/brands/' + dataItem.cta_image"
        thumbnail
        center
      />
      <div class="text-center mt-1">
        <b-button
          variant="primary"
          @click="setModal('cta')"
        >
          <FeatherIcon icon="UploadIcon" />
          Görsel Yükle
        </b-button>
      </div>
    </b-card>
    <cropper-image
      v-if="cropperSettings.type"
      :modal-status="cropperSettings.modalStatus"
      :close-modal="closeModal"
      :file-name="cropperSettings.fileName"
      :folder="cropperSettings.folder"
      :ratio="cropperSettings.ratio"
      :width-size="cropperSettings.widthSize"
      component="brands"
      :params="cropperSettings.type"
      :item-id="dataItem.id"
      @uploadImage="setUploadImage"
    />
  </div>
</template>
<script>
import { BCard, BImg, BButton } from 'bootstrap-vue'
import CropperImage from '@/layouts/components/common/CropperImage.vue'
import { required } from '@core/utils/validations/validations'

export default {
  name: 'ImageCard',
  components: {
    BCard,
    BImg,
    BButton,
    CropperImage,
  },
  data() {
    return {
      cropperSettings: {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        widthSize: null,
        type: null,
      },
      required,
      imageUrl: this.$store.state.app.baseURL,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
  methods: {
    setModal(type) {
      if (type === 'cta') {
        this.cropperSettings = {
          modalStatus: true,
          fileName: 'cta-image.jpg',
          folder: 'brands',
          ratio: 1200 / 800,
          widthSize: 1200,
          type: 'cta',
        }
      }
    },
    closeModal() {
      this.cropperSettings = {
        modalStatus: false,
        fileName: null,
        folder: null,
        ratio: null,
        type: null,
      }
    },
    setUploadImage(item) {
      this.dataItem.cta_image = item.filename
      this.dataItem.cta_thumb = item.thumb
      this.dataItem.cta_image_webp = item.filename_webp
      this.dataItem.cta_thumb_webp = item.thumb_webp
      this.dataItem.cta_mediaData = item
      this.cropperSettings.modalStatus = false
    },
  },
}
</script>
